// extracted by mini-css-extract-plugin
export default {"containerWrapper":"ErrorMessage_containerWrapper__b+4vy","container":"ErrorMessage_container__MOi5y","errorMessage":"ErrorMessage_errorMessage__PBDxX"};